//import React from 'react';

export default function Loading(props) {
    return null
//    return <img src="loading/bb8.gif" alt="loading indicator"/>
}